module.exports = __webpack_public_path__ + "static/media/HR-Background.b69e7ebf.jpg";